import { Form, InputNumber, Select, Space, Table, Tooltip } from 'antd';
import { useRef } from 'react';
import { maskingOptions } from './audiometryConfig';
import { handleVerticalTab, getLeafColumns } from './audiometryUtils';

const AudiometryTable = ({
  form,
  dataSource,
  firstColumnTitle,
  columnsConfig,
  onValueChange,
  disableForm,
  showMasking = false,
  isInteger = false,
}) => {
  const inputRefs = useRef({});
  const leafColumns = getLeafColumns(columnsConfig);

  const handleFocusNext = (col, row) => {
    inputRefs.current[`${col}-${row}`]?.focus();
  };

  const mapConfigToTableColumns = (config) => {
    return config.map((column) => {
      if (column.children) {
        return {
          ...column,
          align: 'center',
          children: mapConfigToTableColumns(column.children),
        };
      }

      return {
        ...column,
        key: column.dataIndex,
        align: 'center',
        width: showMasking ? 60 : 40,
        className: column.className || '',
        render: (_, record, rowIndex) => {
          const colIndex = leafColumns.findIndex(
            (leafColumn) => leafColumn.dataIndex === column.dataIndex,
          );

          return (
            <Form.Item shouldUpdate noStyle>
              <Space size={8} align='start'>
                <Form.Item name={[record.value, column.dataIndex]} noStyle>
                  <InputNumber
                    ref={(element) => (inputRefs.current[`${colIndex}-${rowIndex}`] = element)}
                    onKeyDown={(event) =>
                      handleVerticalTab(
                        event,
                        { colIndex, rowIndex },
                        { totalCols: leafColumns.length, totalRows: dataSource.length },
                        handleFocusNext
                      )
                    }
                    onFocus={(event) => event.target.select()}
                    style={{ width: showMasking ? 60 : '100%' }}
                    disabled={disableForm}
                    controls
                    min={-10}
                    max={120}
                    step={isInteger ? 5 : undefined}
                  precision={0}
                    onChange={(val) =>
                      onValueChange(val, record.value, column.dataIndex)
                    }
                  />
                </Form.Item>

                {showMasking && (
                  <Form.Item
                    name={[record.value, `${column.dataIndex}_masking`]}
                    noStyle
                    initialValue='none'
                  >
                    <Select
                      tabIndex={-1}
                      style={{ width: 70 }}
                      disabled={disableForm}
                      onKeyDown={(event) =>
                        handleVerticalTab(
                          event,
                          { colIndex, rowIndex },
                          {
                            totalCols: leafColumns.length,
                            totalRows: dataSource.length,
                          },
                          handleFocusNext
                        )
                      }
                      onChange={(val) => {
                        onValueChange(
                          val,
                          record.value,
                          `${column.dataIndex}_masking`,
                        );
                      }}
                      optionLabelProp='label'
                      dropdownMatchSelectWidth={false}
                    >
                      <Select.Option value='none' label=' '>
                        Sin selección
                      </Select.Option>
                      {Object.values(maskingOptions).map((option) => (
                        <Select.Option
                          key={option.value}
                          value={option.value}
                          label={
                            <Tooltip title={option.tooltip} placement='right'>
                              <span>{option.suffix}</span>
                            </Tooltip>
                          }
                        >
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Space>
            </Form.Item>
          );
        },
      };
    });
  };

  const tableColumns = [
    {
      title: firstColumnTitle,
      dataIndex: 'value',
      fixed: 'left',
      width: 60,
      align: 'left',
    },
    ...mapConfigToTableColumns(columnsConfig),
  ];

  return (
    <>
      <Table
        className='cmt-table compact-audiometry-table'
        dataSource={dataSource.map((frequency) => ({
          key: frequency,
          value: frequency,
        }))}
        pagination={false}
        columns={tableColumns}
        rowKey='value'
        bordered
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};

export default AudiometryTable;

